var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "mb-5 px-md-5 form-page", attrs: { fluid: "" } },
    [
      _vm.SHOULD_SHOW_PAYMENT_FAILED_BANNER
        ? _c("fixed-banner", { attrs: { type: "error" } }, [
            _vm._v("\n    " + _vm._s(_vm.paymentFailureMessage) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.loading
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "10" } },
                [_c("account-plan-loader")],
                1
              )
            : _c(
                "b-col",
                { attrs: { cols: "12", md: "10" } },
                [
                  _c("page-header", {
                    attrs: {
                      title: _vm.pageTitle,
                      subtitle: _vm.pageSubtitle,
                      "container-class": "justify-content-start",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pb-4" },
                    [
                      _c("navigation-bar", {
                        attrs: {
                          tabs: _vm.tabs,
                          "current-tab": _vm.currentTab,
                        },
                        on: { "tab-change": _vm.handleTabChange },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(_vm.currentTabComponent, { tag: "component" }),
                  _vm._v(" "),
                  _vm.paymentFailure
                    ? _c("b-row", { staticClass: "mt-5" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn-moregage-login btn-primary centered btn white-text clickable",
                            on: { click: _vm.closeSessionAndLogin },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.actions.backToLogin")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }